"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = {
  $schema: '../assetlist.schema.json',
  chain_name: 'osmosis',
  assets: [{
    description: 'The native token of Osmosis',
    denom_units: [{
      denom: 'uosmo',
      exponent: 0
    }, {
      denom: 'osmo',
      exponent: 6
    }],
    base: 'uosmo',
    name: 'Osmosis',
    display: 'osmo',
    symbol: 'OSMO',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg'
    },
    coingecko_id: 'osmosis',
    keywords: ['dex', 'staking'],
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg'
    }]
  }, {
    denom_units: [{
      denom: 'uion',
      exponent: 0
    }, {
      denom: 'ion',
      exponent: 6
    }],
    base: 'uion',
    name: 'Ion DAO',
    display: 'ion',
    symbol: 'ION',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.svg'
    },
    coingecko_id: 'ion',
    keywords: ['memecoin'],
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.svg'
    }]
  }, {
    denom_units: [{
      denom: 'factory/osmo14klwqgkmackvx2tqa0trtg69dmy0nrg4ntq4gjgw2za4734r5seqjqm4gm/uibcx',
      exponent: 0
    }, {
      denom: 'ibcx',
      exponent: 6
    }],
    address: 'osmo14klwqgkmackvx2tqa0trtg69dmy0nrg4ntq4gjgw2za4734r5seqjqm4gm',
    base: 'factory/osmo14klwqgkmackvx2tqa0trtg69dmy0nrg4ntq4gjgw2za4734r5seqjqm4gm/uibcx',
    name: 'IBC Index',
    display: 'ibcx',
    symbol: 'IBCX',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ibcx.svg'
    },
    coingecko_id: 'ibc-index',
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ibcx.svg'
    }]
  }, {
    denom_units: [{
      denom: 'factory/osmo1xqw2sl9zk8a6pch0csaw78n4swg5ws8t62wc5qta4gnjxfqg6v2qcs243k/stuibcx',
      exponent: 0
    }, {
      denom: 'stibcx',
      exponent: 6
    }],
    address: 'osmo1xqw2sl9zk8a6pch0csaw78n4swg5ws8t62wc5qta4gnjxfqg6v2qcs243k',
    base: 'factory/osmo1xqw2sl9zk8a6pch0csaw78n4swg5ws8t62wc5qta4gnjxfqg6v2qcs243k/stuibcx',
    name: 'Staked IBCX',
    display: 'stibcx',
    symbol: 'stIBCX',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/stibcx.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/stibcx.svg'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/stibcx.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/stibcx.svg'
    }]
  }, {
    denom_units: [{
      denom: 'ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858',
      exponent: 0,
      aliases: ['uusdc']
    }, {
      denom: 'usdc',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858',
    name: 'Axelar USD Coin',
    display: 'usdc',
    symbol: 'USDC.axl',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'axelar',
        base_denom: 'uusdc',
        channel_id: 'channel-3'
      },
      chain: {
        channel_id: 'channel-208',
        path: 'transfer/channel-208/uusdc'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'axelar',
        base_denom: 'uusdc'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg'
    }
  }, {
    denom_units: [{
      denom: 'ibc/0B3C3D06228578334B66B57FBFBA4033216CEB8119B27ACDEE18D92DA5B28D43',
      exponent: 0,
      aliases: ['avalanche-uusdc']
    }, {
      denom: 'avalanche-usdc',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/0B3C3D06228578334B66B57FBFBA4033216CEB8119B27ACDEE18D92DA5B28D43',
    name: 'Wormhole USDC(Avalanche)',
    display: 'avalanche-usdc',
    symbol: 'avalanche.USDC.wh',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'gateway',
        base_denom: 'factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4',
        channel_id: 'channel-3'
      },
      chain: {
        channel_id: 'channel-2186',
        path: 'transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4'
      }
    }],
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.svg'
    }
  }, {
    denom_units: [{
      denom: 'ibc/498A0751C798A0D9A389AA3691123DADA57DAA4FE165D5C75894505B876BA6E4',
      exponent: 0,
      aliases: ['uusdc']
    }, {
      denom: 'usdc',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/498A0751C798A0D9A389AA3691123DADA57DAA4FE165D5C75894505B876BA6E4',
    name: 'Noble USD Coin',
    display: 'usdc',
    symbol: 'USDC',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'noble',
        base_denom: 'uusdc',
        channel_id: 'channel-1'
      },
      chain: {
        channel_id: 'channel-750',
        path: 'transfer/channel-750/uusdc'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'noble',
        base_denom: 'uusdc'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.svg'
    }
  }, {
    denom_units: [{
      denom: 'ibc/D176154B0C63D1F9C6DCFB4F70349EBF2E2B5A87A05902F57A6AE92B863E9AEC',
      exponent: 0,
      aliases: ['stuosmo']
    }, {
      denom: 'stosmo',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/D176154B0C63D1F9C6DCFB4F70349EBF2E2B5A87A05902F57A6AE92B863E9AEC',
    name: 'stOSMO',
    display: 'stosmo',
    symbol: 'stOSMO',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'stride',
        base_denom: 'stuosmo',
        channel_id: 'channel-5'
      },
      chain: {
        channel_id: 'channel-326',
        path: 'transfer/channel-326/stuosmo'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'stride',
        base_denom: 'stuosmo'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg'
    }
  }, {
    denom_units: [{
      denom: 'ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2',
      exponent: 0,
      aliases: ['uatom']
    }, {
      denom: 'atom',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2',
    name: 'Cosmos Hub Atom',
    display: 'atom',
    symbol: 'ATOM',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'cosmoshub',
        base_denom: 'uatom',
        channel_id: 'channel-141'
      },
      chain: {
        channel_id: 'channel-0',
        path: 'transfer/channel-0/uatom'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'cosmoshub',
        base_denom: 'uatom'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg'
    }
  }, {
    denom_units: [{
      denom: 'ibc/C140AFD542AE77BD7DCC83F13FDD8C5E5BB8C4929785E6EC2F4C636F98F17901',
      exponent: 0,
      aliases: ['stuatom']
    }, {
      denom: 'statom',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/C140AFD542AE77BD7DCC83F13FDD8C5E5BB8C4929785E6EC2F4C636F98F17901',
    name: 'stATOM',
    display: 'statom',
    symbol: 'stATOM',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'stride',
        base_denom: 'stuatom',
        channel_id: 'channel-5'
      },
      chain: {
        channel_id: 'channel-326',
        path: 'transfer/channel-326/stuatom'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'stride',
        base_denom: 'stuatom'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg'
    }
  }, {
    denom_units: [{
      denom: 'ibc/EA1D43981D5C9A1C4AAEA9C23BB1D4FA126BA9BC7020A25E0AE4AA841EA25DC5',
      exponent: 0,
      aliases: ['weth-wei']
    }, {
      denom: 'weth',
      exponent: 18
    }],
    type_asset: 'ics20',
    base: 'ibc/EA1D43981D5C9A1C4AAEA9C23BB1D4FA126BA9BC7020A25E0AE4AA841EA25DC5',
    name: 'Wrapped Ether',
    display: 'weth',
    symbol: 'ETH',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'axelar',
        base_denom: 'weth-wei',
        channel_id: 'channel-3'
      },
      chain: {
        channel_id: 'channel-208',
        path: 'transfer/channel-208/weth-wei'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'axelar',
        base_denom: 'weth-wei'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/weth.png'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/weth.png'
    }
  }, {
    denom_units: [{
      denom: 'ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F',
      exponent: 0,
      aliases: ['wbtc-satoshi']
    }, {
      denom: 'wbtc',
      exponent: 8
    }],
    type_asset: 'ics20',
    base: 'ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F',
    name: 'Wrapped Bitcoin (Axelar)',
    display: 'wbtc',
    symbol: 'WBTC.axl',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'axelar',
        base_denom: 'wbtc-satoshi',
        channel_id: 'channel-3'
      },
      chain: {
        channel_id: 'channel-208',
        path: 'transfer/channel-208/wbtc-satoshi'
      }
    }],
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.svg',
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.png'
    }, {
      image_sync: {
        chain_name: 'axelar',
        base_denom: 'wbtc-satoshi'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png'
    }],
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.svg',
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.png'
    }
  }, {
    description: 'ERIS liquid staked OSMO',
    denom_units: [{
      denom: 'factory/osmo1dv8wz09tckslr2wy5z86r46dxvegylhpt97r9yd6qc3kyc6tv42qa89dr9/ampOSMO',
      exponent: 0
    }, {
      denom: 'ampOSMO',
      exponent: 6
    }],
    address: 'osmo1dv8wz09tckslr2wy5z86r46dxvegylhpt97r9yd6qc3kyc6tv42qa89dr9',
    base: 'factory/osmo1dv8wz09tckslr2wy5z86r46dxvegylhpt97r9yd6qc3kyc6tv42qa89dr9/ampOSMO',
    name: 'ERIS Amplified OSMO',
    display: 'ampOSMO',
    symbol: 'ampOSMO',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/amposmo.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/amposmo.png'
    }]
  }, {
    description: 'Tether USDT on Osmosis',
    denom_units: [{
      denom: 'ibc/4ABBEF4C8926DDDB320AE5188CFD63267ABBCEFC0583E4AE05D6E5AA2401DDAB',
      exponent: 0
    }, {
      denom: 'usdt',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/4ABBEF4C8926DDDB320AE5188CFD63267ABBCEFC0583E4AE05D6E5AA2401DDAB',
    name: 'Tether USDT',
    display: 'usdt',
    symbol: 'USDT',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'kava',
        base_denom: 'erc20/tether/usdt',
        channel_id: 'channel-1'
      },
      chain: {
        channel_id: 'channel-143',
        path: 'transfer/channel-143/erc20/tether/usdt'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'kava',
        base_denom: 'erc20/tether/usdt'
      },
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg'
    }],
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg'
    }
  }, {
    description: "Membrane's CDP-style stablecoin called CDT",
    denom_units: [{
      denom: 'factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt',
      exponent: 0
    }, {
      denom: 'cdt',
      exponent: 6
    }],
    base: 'factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt',
    name: 'CDT Stablecoin',
    display: 'cdt',
    symbol: 'CDT',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CDT.svg'
    },
    coingecko_id: 'collateralized-debt-token',
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CDT.svg'
    }]
  }, {
    description: "Membrane's protocol token",
    denom_units: [{
      denom: 'factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn',
      exponent: 0
    }, {
      denom: 'mbrn',
      exponent: 6
    }],
    base: 'factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn',
    name: 'Membrane',
    display: 'mbrn',
    symbol: 'MBRN',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/MBRN.svg'
    },
    coingecko_id: 'membrane',
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/MBRN.svg'
    }]
  }, {
    description: 'TIA on Osmosis',
    denom_units: [{
      denom: 'ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877',
      exponent: 0,
      aliases: ['utia']
    }, {
      denom: 'tia',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877',
    name: 'Celestia TIA',
    display: 'tia',
    symbol: 'TIA',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'celestia',
        base_denom: 'utia',
        channel_id: 'channel-2'
      },
      chain: {
        channel_id: 'channel-6994',
        path: 'transfer/channel-6994/utia'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'celestia',
        base_denom: 'utia'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg'
    }
  }, {
    description: 'Margined Power Token sqOSMO',
    denom_units: [{
      denom: 'factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/squosmo',
      exponent: 0
    }, {
      denom: 'sqosmo',
      exponent: 6
    }],
    base: 'factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/squosmo',
    name: 'OSMO Squared',
    display: 'sqosmo',
    symbol: 'sqOSMO',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqosmo.svg'
    },
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqosmo.svg'
    }]
  }, {
    description: 'NOIS on Osmosis',
    denom_units: [{
      denom: 'ibc/6928AFA9EA721938FED13B051F9DBF1272B16393D20C49EA5E4901BB76D94A90',
      exponent: 0,
      aliases: ['unois']
    }, {
      denom: 'nois',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/6928AFA9EA721938FED13B051F9DBF1272B16393D20C49EA5E4901BB76D94A90',
    name: 'Nois NOIS',
    display: 'nois',
    symbol: 'NOIS',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'nois',
        base_denom: 'unois',
        channel_id: 'channel-37'
      },
      chain: {
        channel_id: 'channel-8277',
        path: 'transfer/channel-8277/unois'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'nois',
        base_denom: 'unois'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.svg'
    }
  }, {
    description: 'Margined Power Token sqBTC',
    denom_units: [{
      denom: 'factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqbtc',
      exponent: 0
    }, {
      denom: 'sqbtc',
      exponent: 6
    }],
    base: 'factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqbtc',
    name: 'BTC Squared',
    display: 'sqbtc',
    symbol: 'sqBTC',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqbtc.svg'
    },
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqbtc.svg'
    }]
  }, {
    description: 'Margined Power Token sqATOM',
    denom_units: [{
      denom: 'factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqatom',
      exponent: 0
    }, {
      denom: 'sqatom',
      exponent: 6
    }],
    base: 'factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqatom',
    name: 'ATOM Squared',
    display: 'sqatom',
    symbol: 'sqATOM',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqatom.svg'
    },
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqatom.svg'
    }]
  }, {
    description: 'CRO is the native token of the Crypto.org Chain, referred to as Native CRO.',
    denom_units: [{
      denom: 'ibc/E6931F78057F7CC5DA0FD6CEF82FF39373A6E0452BF1FD76910B93292CF356C1',
      exponent: 0,
      aliases: ['basecro']
    }, {
      denom: 'cro',
      exponent: 8
    }],
    type_asset: 'ics20',
    base: 'ibc/E6931F78057F7CC5DA0FD6CEF82FF39373A6E0452BF1FD76910B93292CF356C1',
    name: 'Cronos',
    display: 'cro',
    symbol: 'CRO',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'cryptoorgchain',
        base_denom: 'basecro',
        channel_id: 'channel-10'
      },
      chain: {
        channel_id: 'channel-5',
        path: 'transfer/channel-5/basecro'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'cryptoorgchain',
        base_denom: 'basecro'
      },
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg'
    }],
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg'
    }
  }, {
    description: 'The native token of Stargaze',
    denom_units: [{
      denom: 'ibc/987C17B11ABC2B20019178ACE62929FE9840202CE79498E29FE8E5CB02B7C0A4',
      exponent: 0,
      aliases: ['ustars']
    }, {
      denom: 'stars',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/987C17B11ABC2B20019178ACE62929FE9840202CE79498E29FE8E5CB02B7C0A4',
    name: 'Stargaze',
    display: 'stars',
    symbol: 'STARS',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'stargaze',
        base_denom: 'ustars',
        channel_id: 'channel-0'
      },
      chain: {
        channel_id: 'channel-75',
        path: 'transfer/channel-75/ustars'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'stargaze',
        base_denom: 'ustars'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg'
    }
  }, {
    description: 'Maximize ETH yield through leveraged staking across Aave, Compound and Morpho and liquidity provision of ETH liquid staking tokens on Uniswap V3.',
    denom_units: [{
      denom: 'ibc/FBB3FEF80ED2344D821D4F95C31DBFD33E4E31D5324CAD94EF756E67B749F668',
      exponent: 0,
      aliases: ['0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec', 'yieldeth-wei']
    }, {
      denom: 'YieldETH',
      exponent: 18
    }],
    type_asset: 'ics20',
    base: 'ibc/FBB3FEF80ED2344D821D4F95C31DBFD33E4E31D5324CAD94EF756E67B749F668',
    name: 'Real Yield Eth',
    display: 'YieldETH',
    symbol: 'YieldETH',
    traces: [{
      type: 'liquid-stake',
      counterparty: {
        chain_name: 'ethereum',
        base_denom: 'wei'
      },
      provider: 'Seven Seas & DeFine Logic Labs'
    }, {
      type: 'bridge',
      counterparty: {
        chain_name: 'ethereum',
        base_denom: '0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec'
      },
      provider: 'Axelar'
    }, {
      type: 'ibc',
      counterparty: {
        chain_name: 'axelar',
        base_denom: 'yieldeth-wei',
        channel_id: 'channel-3'
      },
      chain: {
        channel_id: 'channel-208',
        path: 'transfer/channel-208/yieldeth-wei'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'ethereum',
        base_denom: 'wei'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg'
    }
  }, {
    description: 'The native staking token of dYdX Protocol.',
    denom_units: [{
      denom: 'ibc/831F0B1BBB1D08A2B75311892876D71565478C532967545476DF4C2D7492E48C',
      exponent: 0,
      aliases: ['adydx']
    }, {
      denom: 'dydx',
      exponent: 18
    }],
    type_asset: 'ics20',
    base: 'ibc/831F0B1BBB1D08A2B75311892876D71565478C532967545476DF4C2D7492E48C',
    name: 'dYdX',
    display: 'dydx',
    symbol: 'DYDX',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'dydx',
        base_denom: 'adydx',
        channel_id: 'channel-3'
      },
      chain: {
        channel_id: 'channel-6787',
        path: 'transfer/channel-6787/adydx'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'dydx',
        base_denom: 'adydx'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg'
    }
  }, {
    description: 'The native token of Quasar',
    denom_units: [{
      denom: 'ibc/1B708808D372E959CD4839C594960309283424C775F4A038AAEBE7F83A988477',
      exponent: 0,
      aliases: ['uqsr']
    }, {
      denom: 'qsr',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/1B708808D372E959CD4839C594960309283424C775F4A038AAEBE7F83A988477',
    name: 'Quasar',
    display: 'qsr',
    symbol: 'QSR',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'quasar',
        base_denom: 'uqsr',
        channel_id: 'channel-1'
      },
      chain: {
        channel_id: 'channel-688',
        path: 'transfer/channel-688/uqsr'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'quasar',
        base_denom: 'uqsr'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png'
    }
  }, {
    description: 'Levana native token',
    denom_units: [{
      denom: 'factory/osmo1mlng7pz4pnyxtpq0akfwall37czyk9lukaucsrn30ameplhhshtqdvfm5c/ulvn',
      exponent: 0
    }, {
      denom: 'lvn',
      exponent: 6
    }],
    base: 'factory/osmo1mlng7pz4pnyxtpq0akfwall37czyk9lukaucsrn30ameplhhshtqdvfm5c/ulvn',
    name: 'Levana',
    display: 'lvn',
    symbol: 'LVN',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/levana.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/levana.svg'
    },
    coingecko_id: 'levana-protocol',
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/levana.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/levana.svg'
    }, {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/levana.png'
    }]
  }, {
    description: "MilkyWay's liquid staked TIA",
    denom_units: [{
      denom: 'factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA',
      exponent: 0
    }, {
      denom: 'milkTIA',
      exponent: 6
    }],
    base: 'factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA',
    name: 'milkTIA',
    display: 'milkTIA',
    symbol: 'milkTIA',
    traces: [{
      type: 'liquid-stake',
      counterparty: {
        chain_name: 'celestia',
        base_denom: 'utia'
      },
      provider: 'MilkyWay'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.svg'
    },
    coingecko_id: 'milkyway-staked-tia',
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.svg'
    }]
  }, {
    denom_units: [{
      denom: 'ibc/ECBE78BF7677320A93E7BA1761D144BCBF0CBC247C290C049655E106FE5DC68E',
      exponent: 0,
      aliases: ['stk/uosmo']
    }, {
      denom: 'stkosmo',
      exponent: 6,
      aliases: ['stk/osmo']
    }],
    type_asset: 'ics20',
    base: 'ibc/ECBE78BF7677320A93E7BA1761D144BCBF0CBC247C290C049655E106FE5DC68E',
    name: 'PSTAKE staked OSMO',
    display: 'stkosmo',
    symbol: 'stkOSMO',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'persistence',
        base_denom: 'stk/uosmo',
        channel_id: 'channel-6'
      },
      chain: {
        channel_id: 'channel-4',
        path: 'transfer/channel-4/stk/uosmo'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'persistence',
        base_denom: 'stk/uosmo'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.svg'
    }
  }, {
    description: 'The PAGE token is used for actions in the PageDAO NFT literary ecosystem and for DAO governance.',
    denom_units: [{
      denom: 'ibc/23A62409E4AD8133116C249B1FA38EED30E500A115D7B153109462CD82C1CD99',
      exponent: 0,
      aliases: ['gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e', '0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e']
    }, {
      denom: 'page',
      exponent: 8
    }],
    type_asset: 'ics20',
    base: 'ibc/23A62409E4AD8133116C249B1FA38EED30E500A115D7B153109462CD82C1CD99',
    name: 'PageDAO',
    display: 'page',
    symbol: 'PAGE.grv',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'gravity',
        base_denom: 'gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e',
        channel_id: 'channel-10'
      },
      chain: {
        channel_id: 'channel-144',
        path: 'transfer/channel-144/gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'gravitybridge',
        base_denom: 'gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.svg'
    }
  }, {
    description: "Nomic's native token.",
    denom_units: [{
      denom: 'ibc/F49DFB3BC8105C57EE7F17EC2402438825B31212CFDD81681EB87911E934F32C',
      exponent: 0,
      aliases: ['unom']
    }, {
      denom: 'nom',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/F49DFB3BC8105C57EE7F17EC2402438825B31212CFDD81681EB87911E934F32C',
    name: 'Nomic',
    display: 'nomic',
    symbol: 'NOM',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'nomic',
        base_denom: 'unom',
        channel_id: 'channel-1'
      },
      chain: {
        channel_id: 'channel-6897',
        path: 'transfer/channel-6897/unom'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'nomic',
        base_denom: 'unom'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg'
    }
  }, {
    description: 'Bitcoin. On Cosmos.',
    denom_units: [{
      denom: 'ibc/75345531D87BD90BF108BE7240BD721CB2CB0A1F16D4EBA71B09EC3C43E15C8F',
      exponent: 0,
      aliases: ['usat']
    }, {
      denom: 'nbtc',
      exponent: 14
    }],
    type_asset: 'ics20',
    base: 'ibc/75345531D87BD90BF108BE7240BD721CB2CB0A1F16D4EBA71B09EC3C43E15C8F',
    name: 'Nomic Bitcoin',
    display: 'nbtc',
    symbol: 'nBTC',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'nomic',
        base_denom: 'usat',
        channel_id: 'channel-1'
      },
      chain: {
        channel_id: 'channel-6897',
        path: 'transfer/channel-6897/usat'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'nomic',
        base_denom: 'usat'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg'
    }
  }, {
    description: 'AUTISM on Osmosis',
    denom_units: [{
      denom: 'ibc/9DDF52A334F92BC57A9E0D59DFF9984EAC61D2A14E5162605DF601AA58FDFC6D',
      exponent: 0,
      aliases: ['uautism']
    }, {
      denom: 'autism',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/9DDF52A334F92BC57A9E0D59DFF9984EAC61D2A14E5162605DF601AA58FDFC6D',
    name: 'Injective AUTISM',
    display: 'autism',
    symbol: 'AUTISM',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'injective',
        base_denom: 'factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism',
        channel_id: 'channel-8'
      },
      chain: {
        channel_id: 'channel-122',
        path: 'transfer/channel-122/factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'injective',
        base_denom: 'factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/autism.png'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/autism.png'
    }
  }, {
    description: 'Woof on Osmosis',
    denom_units: [{
      denom: 'ibc/9B8EC667B6DF55387DC0F3ACC4F187DA6921B0806ED35DE6B04DE96F5AB81F53',
      exponent: 0,
      aliases: ['uwoof']
    }, {
      denom: 'WOOF',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/9B8EC667B6DF55387DC0F3ACC4F187DA6921B0806ED35DE6B04DE96F5AB81F53',
    name: 'WOOF chihuahua',
    display: 'WOOF',
    symbol: 'WOOF',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'chihuahua',
        base_denom: 'factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uwoof',
        channel_id: 'channel-7'
      },
      chain: {
        channel_id: 'channel-113',
        path: 'transfer/channel-113/factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uwoof'
      }
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/woof.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/woof.png'
    }]
  }, {
    description: 'The native coin of Sneaky Productions.',
    denom_units: [{
      denom: 'ibc/94ED1F172BC633DFC56D7E26551D8B101ADCCC69052AC44FED89F97FF658138F',
      exponent: 0,
      aliases: ['usneaky']
    }, {
      denom: 'sneaky',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/94ED1F172BC633DFC56D7E26551D8B101ADCCC69052AC44FED89F97FF658138F',
    name: 'Sneaky Productions',
    display: 'sneaky',
    symbol: 'SNEAKY',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'stargaze',
        base_denom: 'factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky',
        channel_id: 'channel-0'
      },
      chain: {
        channel_id: 'channel-75',
        path: 'transfer/channel-75/factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky'
      }
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.png'
    }]
  }, {
    denom_units: [{
      denom: 'factory/osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743/wbtc',
      exponent: 0,
      aliases: ['wbtc-satoshi']
    }, {
      denom: 'wbtc',
      exponent: 8
    }],
    address: 'osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743',
    type_asset: 'sdk.coin',
    base: 'factory/osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743/wbtc',
    name: 'Wrapped Bitcoin',
    display: 'wbtc',
    symbol: 'WBTC',
    traces: [{
      type: 'additional-mintage',
      counterparty: {
        chain_name: 'ethereum',
        base_denom: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599'
      },
      provider: 'BitGo, Kyber, and Ren'
    }],
    images: [{
      image_sync: {
        chain_name: 'ethereum',
        base_denom: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg'
    }
  }, {
    description: "The first native memecoin on Osmosis. Crafted by the deftest of hands in the lab of lunacy. It's scientifically anarchic, professionally foolish, and your ticket to the madhouse.",
    denom_units: [{
      denom: 'factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO',
      exponent: 0
    }, {
      denom: 'WOSMO',
      exponent: 6
    }],
    address: 'osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3',
    base: 'factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO',
    name: 'WOSMO',
    display: 'WOSMO',
    symbol: 'WOSMO',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/WOSMO.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/WOSMO.png'
    }]
  }, {
    description: 'NLS on Osmosis',
    denom_units: [{
      denom: 'ibc/D9AFCECDD361D38302AA66EB3BAC23B95234832C51D12489DC451FA2B7C72782',
      exponent: 0,
      aliases: ['unls']
    }, {
      denom: 'nls',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/D9AFCECDD361D38302AA66EB3BAC23B95234832C51D12489DC451FA2B7C72782',
    name: 'Nolus',
    display: 'nls',
    symbol: 'NLS',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'nolus',
        base_denom: 'unls',
        channel_id: 'channel-0'
      },
      chain: {
        channel_id: 'channel-783',
        path: 'transfer/channel-783/unls'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'nolus',
        base_denom: 'unls'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg'
    }
  }, {
    description: 'STRD on Osmosis',
    denom_units: [{
      denom: 'ibc/A8CA5EE328FA10C9519DF6057DA1F69682D28F7D0F5CCC7ECB72E3DCA2D157A4',
      exponent: 0,
      aliases: ['ustrd']
    }, {
      denom: 'strd',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/A8CA5EE328FA10C9519DF6057DA1F69682D28F7D0F5CCC7ECB72E3DCA2D157A4',
    name: 'Stride',
    display: 'strd',
    symbol: 'STRD',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'stride',
        base_denom: 'ustrd',
        channel_id: 'channel-5'
      },
      chain: {
        channel_id: 'channel-326',
        path: 'transfer/channel-326/ustrd'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'stride',
        base_denom: 'ustrd'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg'
    }
  }, {
    description: 'Margined Power Token sqTIA',
    denom_units: [{
      denom: 'factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqtia',
      exponent: 0
    }, {
      denom: 'sqtia',
      exponent: 6
    }],
    base: 'factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqtia',
    name: 'TIA Squared',
    display: 'sqtia',
    symbol: 'sqTIA',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqtia.svg'
    },
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqtia.svg'
    }]
  }, {
    description: 'Sail DAO Token',
    denom_units: [{
      denom: 'factory/osmo1rckme96ptawr4zwexxj5g5gej9s2dmud8r2t9j0k0prn5mch5g4snzzwjv/sail',
      exponent: 0
    }, {
      denom: 'sail',
      exponent: 6
    }],
    base: 'factory/osmo1rckme96ptawr4zwexxj5g5gej9s2dmud8r2t9j0k0prn5mch5g4snzzwjv/sail',
    name: 'Sail',
    display: 'sail',
    symbol: 'SAIL',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sail.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sail.png'
    }]
  }]
};
var _default = exports["default"] = info;